var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbre2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_9",
    "data-name": "Calque 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 519.64 1035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#965d36;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#559914;}.cls-5{fill:#3e7f13;}.cls-6{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1563.35 -1133)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1841.09,1787c-380.58-13.21-118.09-654,0-654C1962,1133,2164.91,1787,1841.09,1787Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-1563.35 -1133)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1748.67,1795c-121.56-3.54-41.17-175.32,0-175.32C1789.11,1619.68,1852.1,1795,1748.67,1795Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arbre 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1850,1749v408c-8.28,0-43.86,11-64,11,0,0,14-269.89,8-269-29-20-65-139-63-160l10,8c16.57,54.78,32.85,114.2,53,112l8-120Z",
    transform: "translate(-1563.35 -1133)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1841.09,1787c-380.58-13.21-141.09-654,0-654C2002,1133,2164.91,1787,1841.09,1787Z",
    transform: "translate(-1563.35 -1133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1995.64,1658.81c-184.05,25.56-284.5-113-333.64-271.81,0,0-98.65,195.63-98.65,204.38s73,211.19,73,211.19l317.41,64.23L2083,1769.48Z",
    transform: "translate(-1563.35 -1133)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1748.67,1795c-121.56-3.54-88-175.32,0-175.32C1819.34,1619.68,1852.1,1795,1748.67,1795Z",
    transform: "translate(-1563.35 -1133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1798,1760.64c-58.78,6.85-95.24-32.64-110.94-75.21,0,0-27.13,54.78-27.13,57.13s23.3,56.61,23.3,56.61l101.39,17.22,41.28-26.09Z",
    transform: "translate(-1563.35 -1133)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbre2);
export default __webpack_public_path__ + "static/media/arbre_2.ac437708c3498843fcdd83cdf218b4f9.svg";
export { ForwardRef as ReactComponent };